import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Wraps the slot the plan broadcasts into (plans/_changed). Each notice
// arrives hidden carrying the plan's version and who changed it. It is shown
// for a newer version from someone else; the viewer's own saves are ignored,
// since the paths that update the page in place never reload it and would
// otherwise announce the viewer's edit back to them. Once a foreign change
// is pending the notice stays up through the viewer's own saves, because the
// page is still stale until they reload.
export default class extends Controller {
  static targets = ["banner"]
  static values = { version: Number, user: Number }

  bannerTargetConnected(banner) {
    const newer = Number(banner.dataset.version) > this.versionValue
    const foreign = Number(banner.dataset.actor) !== this.userValue
    this.stale ||= newer && foreign
    banner.hidden = !this.stale
  }

  // A replace visit lands at the top of the page; put the viewer back where
  // they were, since the notice reaches them however deep in the plan they are.
  // ponytail: Turbo 8 page refresh (morph + scroll: preserve) does this
  // natively and keeps open disclosures too; switch once the plan view is
  // known to morph cleanly.
  refresh() {
    const scrollY = window.scrollY
    this.bannerTarget.setAttribute("aria-busy", "true")
    document.addEventListener("turbo:load", () => window.scrollTo(0, scrollY), { once: true })
    Turbo.visit(window.location.href, { action: "replace" })
  }
}
